import { TargetUserGroups } from '@Policy/Components/TargetUserGroups';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Divider, Flex } from '@tonic-one/react';
import { useGlobalSettingStore } from '@Models/useGlobalSettingModel';
import { FormLabel } from '@Components/Common/FormComponent';
import { GeneralPolicyInfo, GeneralStatus } from '@Policy/Filters/General';
import { useExchangeOnlineTargetUserGroups } from '@Policy/hooks';
import { PocApi } from '@Apis';
import { useOrgStore } from '../../../../../../../models/useOrgModel';

export const TargetUserGroupsExchangeOnline = () => {
  const props = useExchangeOnlineTargetUserGroups();
  const { orgId } = useOrgStore();
  const [isPoc, setIsPoc] = useState(false);

  useEffect(() => {
    //get exchange poc status
    PocApi.apiCheckIsPoc(orgId).then((isPoc) => {
      setIsPoc(isPoc);
    });
  }, [orgId]);
  return <TargetUserGroups {...props} isSyncButtonShow={!isPoc} />;
};
const General = () => {
  const { t } = useTranslation();
  const { selectedOrgGlobalSetting } = useGlobalSettingStore();
  const mipAndTokenFeatureShow =
    !!selectedOrgGlobalSetting?.mipAndTokenFeatureShow;
  return (
    <Box>
      <GeneralStatus
        skipScanJunkEmailFolderShow={true}
        mipEnableFeatureShow={mipAndTokenFeatureShow}
      />
      <Divider mt="22px" mb="22px" />
      <GeneralPolicyInfo />
      <Flex mt="23px" alignItems="flex-start">
        <FormLabel label={t('policy.label.policyTarget')} required />
        <TargetUserGroupsExchangeOnline />
      </Flex>
    </Box>
  );
};
export default React.memo(General);
